import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-4 sm:py-6">
          <div className="flex items-center justify-between">
            <a href="/" className="cursor-pointer">
              <h1 className={`text-2xl sm:text-3xl font-light transition-colors whitespace-nowrap ${
                scrolled ? 'text-gray-900' : 'text-white drop-shadow-lg'
              }`} style={{ fontFamily: '"Pacifico", serif' }}>
                Heritage Water
              </h1>
            </a>
            
            {/* Desktop Menu */}
            <div className="hidden md:flex items-baseline gap-10">
              <a href="/" className={`text-sm font-light hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}>
                Home
              </a>
              <a href="/about" className={`text-sm font-light hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}>
                About Us
              </a>
              <a href="/" className={`text-sm font-light hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}>
                Product
              </a>
              <a href="/" className={`text-sm font-light hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}>
                Contact
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 cursor-pointer"
              aria-label="Toggle menu"
            >
              <i className={`text-2xl transition-colors ${
                scrolled ? 'text-gray-900' : 'text-white'
              } ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>

          {/* Mobile Menu Dropdown */}
          {mobileMenuOpen && (
            <div className={`md:hidden mt-4 py-4 rounded-lg ${
              scrolled ? 'bg-white' : 'bg-white/95 backdrop-blur-md'
            }`}>
              <a href="/" className="block px-4 py-3 text-gray-900 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">
                Home
              </a>
              <a href="/about" className="block px-4 py-3 text-gray-900 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">
                About Us
              </a>
              <a href="/" className="block px-4 py-3 text-gray-900 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">
                Product
              </a>
              <a href="/" className="block px-4 py-3 text-gray-900 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer">
                Contact
              </a>
            </div>
          )}
        </div>
      </nav>

      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/52ec109f852e23dd814cf24ba33d71a4.jpg"
          alt="Heritage Water"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center text-white px-4 sm:px-6 w-full max-w-5xl mx-auto">
        <h2 className="text-4xl sm:text-5xl lg:text-7xl font-light mb-4 sm:mb-6 tracking-tight leading-tight">
          자연이 만든<br />가장 순수한 물
        </h2>
        <p className="text-base sm:text-xl lg:text-2xl font-semibold mb-8 sm:mb-12 leading-relaxed drop-shadow-lg px-4">
          유네스코 생물권보전지역의<br className="sm:hidden" /> 프리미엄 천연미네랄워터
        </p>
        <button className="px-8 sm:px-10 py-3 sm:py-4 bg-white text-gray-900 rounded-full text-sm sm:text-base font-medium hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
          Discover More
        </button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 sm:bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl sm:text-4xl text-white"></i>
      </div>
    </section>
  );
}
